import { API_CALL } from 'actions/actionConstants'
import type { AppAction } from 'actions/types/ActionTypes'
import { FETCH_LOYALTY_PURCHASE_POINTS_OFFERS } from 'actions/apiActionConstants'
import requestLoyaltyPurchasePointsOffers from 'api/loyalty/requestLoyaltyPurchasePointsOffers'
import { getCurrentUserId, selectLoggedIn } from 'selectors/accountSelectors'

export function getLoyaltyPurchasePointsOffersKey(currency: string, customerId?: string): string {
  return customerId ? `${currency}:${customerId}` : currency
}

function fetchLoyaltyPurchasePointsOffers(currency: string, customerId?: string): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const key = getLoyaltyPurchasePointsOffersKey(currency, customerId)

    const cached = state.loyalty.purchaseOffers[key]
    if (cached?.data || cached?.fetching || cached?.error) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_LOYALTY_PURCHASE_POINTS_OFFERS,
      request: () => requestLoyaltyPurchasePointsOffers(currency, customerId),
      key,
    })
  }
}

/**
 * Force-refresh the purchase offers for the current currency/customer if a
 * cached entry already exists (e.g. after a successful purchase invalidates
 * `isEligibleNow` / `nextEligiblePurchaseDate`). No-ops when nothing is cached
 * yet, since there is no consumer holding stale data to refresh.
 */
export function refreshLoyaltyPurchasePointsOffers(): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const currency = state.geo.currentCurrency
    const customerId = selectLoggedIn(state) ? getCurrentUserId(state) : undefined
    const key = getLoyaltyPurchasePointsOffersKey(currency, customerId)

    if (!state.loyalty.purchaseOffers[key]?.data) return

    dispatch({
      type: API_CALL,
      api: FETCH_LOYALTY_PURCHASE_POINTS_OFFERS,
      request: () => requestLoyaltyPurchasePointsOffers(currency, customerId),
      key,
    })
  }
}

export default fetchLoyaltyPurchasePointsOffers
